export var AssetCardDelta;
(function (AssetCardDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["ASSET_CARD_DELTA"] = "asset_card_delta";
    })(type = AssetCardDelta.type || (AssetCardDelta.type = {}));
})(AssetCardDelta || (AssetCardDelta = {}));
